/**
 * CasaMapa partner portal path helpers.
 */
import { casamapaPartnerPortalPath } from "../constants/casamapaPartnerPortalConfig.js";

export const CASAMAPA_PARTNER_DASHBOARD_PATH = casamapaPartnerPortalPath("dashboard");

export const CASAMAPA_PARTNER_LOGIN_PATH = casamapaPartnerPortalPath("login");

export function buildCasaMapaPartnerLoginHref({ intent = null, returnTo = CASAMAPA_PARTNER_DASHBOARD_PATH, mode = null } = {}) {
  const params = new URLSearchParams();
  if (intent) {
    params.set("intent", intent);
  }
  if (returnTo) {
    params.set("returnTo", returnTo);
  }
  if (mode === "register") {
    params.set("mode", "register");
  }
  const query = params.toString();
  return query ? `${CASAMAPA_PARTNER_LOGIN_PATH}?${query}` : CASAMAPA_PARTNER_LOGIN_PATH;
}

export function isCasaMapaPartnerAccountIntent(intent) {
  return intent === "agency" || intent === "vendor";
}
